module.exports = __webpack_public_path__ + "img/Bayanihan-Para-Sa-Magsasaka.d36b6b1e.png";